export default {
    props: ['partner', 'userPosition'],
    data() {
      return {
        open: false,
        isMobile: false,
        aux: {
          seg: null,
          ter: null,
          qua: null,
          qui: null,
          sex: null,
          sab: null,
          dom: null,
        },
        schedulesCombination: {
          combination1: null,
          combination2: null,
        }
      }
    },
    mounted() {
      window.addEventListener('scroll', () => window.scrollY > 0 ? this.isScrolling = true : this.isScrolling = false );

      // saber se está em desktop ou mobile.
      if(window.innerWidth <= 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      this.formatSchedules();
    },

    components:{
    },
    computed: {

      hourWeek() {
        if(this.partner.segunda) {
          if(this.partner.segunda.indexOf('-') > -1) {
            return this.partner.segunda.replace('-',  ' às ');
          }
          return 'Fechado';
        }
      },

      saturdayAndSunday() {
        const {
          sabado,
          domingo
        } = this.partner;

        if(this.formatScheduleMethod(sabado) == this.formatScheduleMethod(domingo)) {
          return `Sab e Dom: ${this.formatScheduleMethod(sabado)}`;
        } else {
          this.aux.sab = `Sab: ${this.formatScheduleMethod(sabado)}`;
          this.aux.dom = `Dom: ${this.formatScheduleMethod(domingo)}`;
          return false;
        }
      },

      tel() {
        if(this.partner.telefone && this.partner.dddTelefone)
          return `tel:${this.partner.dddTelefone}${this.partner.telefone}`;
      }
    },
    filters: {
      formatCep(cep) {
        return `${cep.substring(0, 5)}-${cep.substring(5)}`
      },

      formatDistance(distance) {
        if(distance)
          return distance.toFixed(2);
      },
      formatSchedule(day) {
        return this.formatScheduleMethod(day);
      }
    },
    methods: {

      showModalHorarios (){
        this.$emit("showModalHorarios", 1)
      },
      formatScheduleMethod(day) {
        if(day)
          return day.trim().replace('-', ' às ');
        else
          return 'Fechado';
      },

      checkSchedules() {
        const {
          segunda,
          terca,
          quarta,
          quinta,
          sexta,
          sabado,
          domingo
        } = this.partner;

        if(segunda || terca || quarta || quinta || sexta || sabado || domingo) return true;
        else return false;
      },
      hideDetail() {
        setTimeout(() => {
          this.open = false;
        }, 10);
      },
      showDetail() {
        this.$emit("getMoveMaisId", this.partner.moveMaisId);
        this.open = true;
      },
      openMapWindow() {
        let url;
        url = `https://www.google.com/maps/dir/?api=1&origin=${this.userPosition.latitude},${this.userPosition.longitude}&destination=${this.partner.latitude},${this.partner.longitude}`;
        window.open(url, '_blank', `toolbar=yes, scrollbars=yes, resizable=yes, height=4000, width=4000`);
      },

      formatSchedules() {
        // objeto para ter mais controle dos horários
        const schedules = [
          { id: 0, day: 'Seg', schedule: this.formatScheduleMethod(this.partner.segunda)},
          { id: 1, day: 'Ter', schedule: this.formatScheduleMethod(this.partner.terca)},
          { id: 2, day: 'Qua', schedule: this.formatScheduleMethod(this.partner.quarta)},
          { id: 3, day: 'Qui', schedule: this.formatScheduleMethod(this.partner.quinta)},
          { id: 4, day: 'Sex', schedule: this.formatScheduleMethod(this.partner.sexta)},
        ];

        let previousElement = -1; // elemento anterior
        let schedulesEquals = []; // array de horarios iguais
        const allSchedulesEquals = []; // array de todos os horários iguais
        let schedulesNotEquals = []; // array de horários que não são iguais

        // iteração para verificar se existe horários iguais na semana
        schedules.forEach((element, index) => {
          if(previousElement.schedule == element.schedule) { // horario do dia anterior == horario do dia atual
            schedulesEquals.push(previousElement); // adicionando o horário do dia anterior
            schedulesEquals.push(element); // adicionando o horário do dia atual
          } else if(schedulesEquals.length > 0) { // verificando se já existem horário iguais
            if(!this.schedulesCombination.combination1) { // verificando se a combinação 1 existe
              // exibindo combinação 1
              this.schedulesCombination.combination1 = `${schedulesEquals[0].day} a ${schedulesEquals[schedulesEquals.length - 1].day}: ${schedulesEquals[0].schedule}`;
            } else {
              // exibindo combinação 2
              this.schedulesCombination.combination2 = `${schedulesEquals[0].day} a ${schedulesEquals[schedulesEquals.length - 1].day}: ${schedulesEquals[0].schedule}`;
            }
            // adicionando todas as combinações no array generico
            allSchedulesEquals.push(...schedulesEquals);
            // limpando o array de combinação
            schedulesEquals = [];
          }

          if(index == 4) {    // verificando se está na ultima iteração
            if(schedulesEquals.length) { // verificando se já existem horário iguais
              // exibindo combinação 2
              this.schedulesCombination.combination2 =`${schedulesEquals[0].day} a ${schedulesEquals[schedulesEquals.length - 1].day}: ${schedulesEquals[0].schedule}`;
              // adicionando todas as combinações no array generico
              allSchedulesEquals.push(...schedulesEquals);
            }
          }
          previousElement = element; // elementanterior = elemento atual
        });

        // procurando elementos que não são repetidos
        schedulesNotEquals = schedules.filter( (schedule) => !allSchedulesEquals.includes( schedule ));
        // exibindo esses elementos que não se repetiram
        schedulesNotEquals.forEach(element =>  this.aux[element.day.toLowerCase()] = `${element.day}: ${element.schedule}`);
      }
    },
  }



// WEBPACK FOOTER //
// ./src/components/partner-information/partner-information.js